function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export function headerFooter($) {
  //footer
  jQuery(document).ready(function ($) {
    var isSvgAdded = false; // Track if SVG is added

    // Function to apply accordion behavior
    function enableAccordionMenu() {
      var menuItems = document.querySelectorAll(".menu-footer-menu-container .menu-item-has-children");
      menuItems.forEach(function (item) {
        var link = item.querySelector("a"); // The main menu link
        var subMenu = item.querySelector(".sub-menu"); // The submenu
        var arrow = item.querySelector("svg"); // Check if SVG already exists

        // Add SVG only if it doesn't exist
        if (!arrow) {
          arrow = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          arrow.setAttribute("xmlns", "http://www.w3.org/2000/svg");
          arrow.setAttribute("width", "24");
          arrow.setAttribute("height", "24");
          arrow.setAttribute("viewBox", "0 0 24 24");
          arrow.setAttribute("fill", "none");
          arrow.innerHTML = '<path d="M18 9L12 15L6 9" stroke="#FF3E24" stroke-width="2" stroke-linejoin="round"/>';

          // Append the SVG to the link if it doesn't exist
          link.appendChild(arrow);
        }

        // Initial CSS for the SVG (rotate icon)
        arrow.style.transition = "transform 0.3s ease";

        // Add a click event listener to the parent link
        link.addEventListener("click", function (e) {
          // Prevent default link behavior
          e.preventDefault();

          // Toggle submenu visibility using the "show" class
          subMenu.classList.toggle("show");

          // Rotate the arrow icon
          if (subMenu.classList.contains("show")) {
            arrow.style.transform = "rotate(180deg)"; // Rotate 180deg when submenu is shown
          } else {
            arrow.style.transform = "rotate(0deg)"; // Reset rotation when submenu is hidden
          }
        });

        // Initially hide the submenu
        subMenu.classList.remove("show");
      });
    }

    // Function to handle resize event
    function handleResize() {
      if (window.innerWidth < 992) {
        // Bootstrap's md breakpoint is 992px
        enableAccordionMenu();
      } else {
        // Remove the SVG and reset submenu visibility for larger screens
        var arrows = document.querySelectorAll("svg");
        arrows.forEach(function (arrow) {
          return arrow.remove();
        }); // Remove all arrows (clean up)

        // Reset all submenus to be visible again if needed for larger screens
        var subMenus = document.querySelectorAll(".sub-menu");
        subMenus.forEach(function (subMenu) {
          subMenu.classList.remove("show");
          subMenu.style.display = "block"; // Make sure it's visible
        });
      }
    }

    // Run the function initially and on window resize
    handleResize();
    window.addEventListener("resize", handleResize);
  });
  jQuery(document).ready(function ($) {
    function updateTime() {
      var options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      };
      var maltaTime = new Date().toLocaleTimeString('en-GB', _objectSpread(_objectSpread({}, options), {}, {
        timeZone: 'Europe/Malta'
      }));
      document.getElementById('current-time').textContent = maltaTime + ' MT';
    }
    setInterval(updateTime, 1000);
    updateTime();
    document.querySelectorAll('.menu-item-has-children > a').forEach(function (item) {
      item.addEventListener('mouseenter', function (e) {
        e.preventDefault();
        var parentLi = this.parentElement;
        var submenuWrapper = parentLi.querySelector('.sub-menu__wrapper');
        if (submenuWrapper) {
          document.querySelectorAll('.menu-item-has-children.active').forEach(function (otherItem) {
            if (otherItem !== parentLi) {
              otherItem.classList.remove('active');
              var otherSubmenu = otherItem.querySelector('.sub-menu__wrapper');
              if (otherSubmenu) {
                otherSubmenu.style.opacity = '0';
                otherSubmenu.style.visibility = 'hidden';
                otherSubmenu.style.maxHeight = '0px';
                $('header .menu-section').css('border-bottom', '1px solid #E6EBF1');
              }
            }
          });
          // Store the timeout ID
          var timeoutId;
          timeoutId = setTimeout(function () {
            parentLi.classList.add('active');
            submenuWrapper.style.opacity = '1';
            submenuWrapper.style.visibility = 'visible';
            submenuWrapper.style.maxHeight = '10000px'; // Adjust height as needed
            submenuWrapper.style.height = 'max-content';
            $('header .menu-section').css('border-bottom', 'none');

            // Add mouseleave event to hide submenu
            submenuWrapper.addEventListener('mouseleave', function () {
              parentLi.classList.remove('active');
              submenuWrapper.style.opacity = '0';
              submenuWrapper.style.visibility = 'hidden';
              submenuWrapper.style.maxHeight = '0px';
              $('header .menu-section').css('border-bottom', '1px solid #E6EBF1');
            });
          }, 400);

          // Cancel the actions inside the timeout if the mouse leaves before it completes
          item.addEventListener('mouseleave', function () {
            clearTimeout(timeoutId); // Clear the timeout and cancel the actions
          });
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.menu-item-has-children')) {
        document.querySelectorAll('.menu-item-has-children.active').forEach(function (activeItem) {
          activeItem.classList.remove('active');
          var activeSubmenu = activeItem.querySelector('.sub-menu__wrapper');
          if (activeSubmenu) {
            activeSubmenu.style.opacity = '0';
            activeSubmenu.style.visibility = 'hidden';
            activeSubmenu.style.maxHeight = '0px';
            $('header .menu-section').css('border-bottom', '1px solid #E6EBF1');
          }
        });
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      var menuItems = document.querySelectorAll('.nav-item.has-submenu');
      menuItems.forEach(function (item) {
        var toggleIcon = item.querySelector('.submenu-toggle-icon');
        var submenuWrapper = item.querySelector('.sub-menu__wrapper');
        if (toggleIcon && submenuWrapper) {
          toggleIcon.addEventListener('click', function (e) {
            e.preventDefault();
            menuItems.forEach(function (otherItem) {
              if (otherItem !== item && otherItem.classList.contains('open')) {
                otherItem.classList.remove('open');
                var otherSubmenu = otherItem.querySelector('.sub-menu__wrapper');
                if (otherSubmenu) {
                  otherSubmenu.style.opacity = '0';
                  otherSubmenu.style.visibility = 'hidden';
                  otherSubmenu.style.maxHeight = '0px';
                  $('header .menu-section').css('border-bottom', '1px solid #E6EBF1');
                }
              }
            });
            // Store the timeout ID
            var timeoutId;
            timeoutId = setTimeout(function () {
              parentLi.classList.add('active');
              submenuWrapper.style.opacity = '1';
              submenuWrapper.style.visibility = 'visible';
              submenuWrapper.style.maxHeight = '10000px'; // Adjust height as needed
              submenuWrapper.style.height = 'max-content';
              $('header .menu-section').css('border-bottom', 'none');

              // Add mouseleave event to hide submenu
              submenuWrapper.addEventListener('mouseleave', function () {
                parentLi.classList.remove('active');
                submenuWrapper.style.opacity = '0';
                submenuWrapper.style.visibility = 'hidden';
                submenuWrapper.style.maxHeight = '0px';
                $('header .menu-section').css('border-bottom', '1px solid #E6EBF1');
              });
            }, 400);

            // Cancel the actions inside the timeout if the mouse leaves before it completes
            item.addEventListener('mouseleave', function () {
              clearTimeout(timeoutId); // Clear the timeout and cancel the actions
            });
          });
          submenuWrapper.addEventListener('mouseleave', function () {
            item.classList.remove('open');
            submenuWrapper.style.opacity = '0';
            submenuWrapper.style.visibility = 'hidden';
            submenuWrapper.style.maxHeight = '0px';
            $('header .menu-section').css('border-bottom', '1px solid #E6EBF1');
          });
        }
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.nav-item.has-submenu')) {
          menuItems.forEach(function (item) {
            if (item.classList.contains('open')) {
              item.classList.remove('open');
              var submenuWrapper = item.querySelector('.sub-menu__wrapper');
              if (submenuWrapper) {
                submenuWrapper.style.opacity = '0';
                submenuWrapper.style.visibility = 'hidden';
                submenuWrapper.style.maxHeight = '0px';
                $('header .menu-section').css('border-bottom', '1px solid #E6EBF1');
              }
            }
          });
        }
      });
    });
  });
  jQuery(document).ready(function ($) {
    var menuSection = document.querySelector(".menu-section");
    var menuOffset = menuSection.offsetTop;
    window.addEventListener("scroll", function () {
      if (window.scrollY >= menuOffset) {
        menuSection.classList.add("sticky-header");
      } else {
        menuSection.classList.remove("sticky-header");
      }
    });
  });
  var burgerMenu = document.getElementById('burgerMenu');
  var menuOverlay = document.getElementById('headermenuOverlay');
  burgerMenu.addEventListener('click', function () {
    burgerMenu.classList.toggle('active');
    menuOverlay.classList.toggle('active');
  });
  jQuery(document).ready(function ($) {
    // Select all menu items with children
    var menuItems = document.querySelectorAll('#headermenuOverlay .menu-item-has-children > .nav-link');
    menuItems.forEach(function (menuItem) {
      menuItem.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default link behavior

        var submenuWrapper = this.nextElementSibling; // Get the submenu wrapper
        var isOpen = submenuWrapper.classList.contains('open');

        // Close all other open submenus
        document.querySelectorAll('.sub-menu__wrapper.open').forEach(function (openSubmenu) {
          openSubmenu.classList.remove('open');
          openSubmenu.previousElementSibling.querySelector('.submenu-toggle-icon').style.transform = 'rotate(0deg)';
        });
        if (!isOpen) {
          // Open the clicked submenu
          submenuWrapper.classList.add('open');
          this.querySelector('.submenu-toggle-icon').style.transform = 'rotate(180deg)';
        } else {
          // Close the submenu if it's already open
          submenuWrapper.classList.remove('open');
          this.querySelector('.submenu-toggle-icon').style.transform = 'rotate(0deg)';
        }
      });
    });
  });
}